export const getCNVTranscripts = (state) =>
  state.variantResult && state.variantResult.transcripts;

export const getCnvsCodingGenes = (state) => state.cnvCodingGenes;
export const getCnvPathogenicGenes = (state) =>
  state?.variantResult?.sv_acmg_annotation?.sample_findings
    ?.patho_gene_to_diseases;
export const getVariantQueryMode = (state) => state?.variantQueryMode;
export const getCnvACMGAnnotationFindings = (state) =>
  state?.variantResult?.sv_acmg_annotation?.sample_findings;
